import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 40,
    height: 40,
    fill: "transparent"
  }
});

class IcGreenArrowRight extends React.Component {

  render() {
    const { classes, className, onClick } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 40 40" } 
                    onClick = { onClick }>
      <rect x="-1" y="1" width="38" height="38" rx="3" transform="matrix(-1 0 0 1 38 0)" stroke="#54BAC1" strokeWidth="2"/>
      <path d="M17.5 27.5L25 20L17.5 12.5" stroke="#54BAC1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcGreenArrowRight);
